import Search from "./Search";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function TopRibbon() {
  return (
    <>
      <div className="max-container-width py-2 primary-text-blue">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <Link to="/" className="order-1 p-2">
            <img style={{ width: "10rem" }} src="/img/logo-full.png" alt="" />
          </Link>
          <div className="order-3 order-md-2 p-2 searchbox-width">
            <Search />
          </div>
          <div className="order-2 order-md-3 p-2">
            <div className="d-flex gap-3 justify-content-end">
              <a
                href="https://www.youtube.com/@ummatproduction7091"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  fill="currentColor"
                  className="bi bi-youtube"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/people/Ummat-Production-%D8%A7%D9%85%D8%AA-%D9%BE%D8%B1%D9%88%D8%AF%DA%A9%D8%B4%D9%86/61579394770099/?rdid=CwgcDRyrGSO60ivv&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FeAvWiwgi%2F"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  fill="currentColor"
                  className="bi bi-facebook"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                </svg>
              </a>
              <a
                href="http://bitly.cx/gCiQ"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  fill="currentColor"
                  className="bi bi-twitter-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
                </svg>
              </a>
              <a
                href="https://t.me/UmmatNews21"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-circle p-2 text-body btn btn-default btn-circle shadow-sm icon-links border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="25"
                  fill="currentColor"
                  className="bi bi-telegram"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
